/* Beyond Radix · slimmer, frosted header once the page scrolls (every page) */
(function () {
  var root = document.documentElement, on = false, ticking = false;
  function check() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset;
    var want = on ? y > 80 : y > 120;
    if (want !== on) { on = want; root.classList.toggle('br-head-slim', on); }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  check();
})();

/* Footer link groups fold into dropdowns on phones */
(function () {
  function setup() {
    var mq = window.matchMedia('(max-width: 749px)');
    var blocks = Array.prototype.slice.call(document.querySelectorAll('footer.footer .footer-block'));
    blocks.forEach(function (b) {
      var h = b.querySelector('.footer-block__heading'), c = b.querySelector('.footer-block__details-content');
      if (!h || !c || b.__brFold) return;
      b.__brFold = true;
      var inner = document.createElement('div');
      while (c.firstChild) inner.appendChild(c.firstChild);
      c.appendChild(inner);
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-expanded', 'false');
      function toggle() { if (!mq.matches) return; var open = !b.classList.contains('is-open'); b.classList.toggle('is-open', open); h.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      b.classList.add('br-fold');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* Banner for the blog and policy pages, matching the rest of the site */
(function () {
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function hero(o) {
    var s = document.createElement('section');
    s.className = 'br-ph';
    s.innerHTML = '<div class="page-width br-ph__in">' +
      '<nav class="br-ph__crumbs" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">/</span><span>' + esc(o.crumb) + '</span></nav>' +
      '<p class="br-ph__eyebrow"><i aria-hidden="true"></i>' + esc(o.eyebrow) + '</p>' +
      '<h1 class="br-ph__title">' + o.title + '</h1>' +
      (o.lead ? '<p class="br-ph__lead">' + esc(o.lead) + '</p>' : '') +
      '</div><div class="br-ph__art" aria-hidden="true"><span></span><span></span><span></span></div>';
    return s;
  }
  function run() {
    var main = document.querySelector('main#MainContent') || document.querySelector('main');
    if (!main || main.querySelector('.br-ph')) return;
    var blog = main.querySelector('.main-blog');
    if (blog) {
      var h = blog.querySelector('h1.title');
      var name = h ? h.textContent.trim() : 'Recovery guides';
      var words = name.split(' '), last = words.pop();
      main.insertBefore(hero({ crumb: 'Blog', eyebrow: 'From the clinic', title: esc(words.join(' ')) + (words.length ? ' ' : '') + '<em>' + esc(last) + '</em>', lead: 'Practical, plain-language advice from a physical therapist: what to do, what to avoid, and how to keep moving while you recover.' }), main.firstElementChild);
      return;
    }
    var pol = main.querySelector('.shopify-policy__container');
    if (pol) {
      var t = main.querySelector('.shopify-policy__title h1');
      var title = t ? t.textContent.trim() : 'Policy';
      main.insertBefore(hero({ crumb: title, eyebrow: 'The fine print, made clear', title: esc(title), lead: 'Everything about how we handle your order and your information, written to be read. Questions? Our team is happy to help.' }), main.firstElementChild);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Footer base: real brand name in the copyright line */
(function () {
  function run() {
    var c = document.querySelector('footer.footer .footer__copyright');
    if (!c || c.__br) return; c.__br = true;
    var smalls = c.querySelectorAll('.copyright__content');
    smalls.forEach(function (s) {
      if (/powered by/i.test(s.textContent)) { s.remove(); return; }
      var a = s.querySelector('a');
      if (a && /my store/i.test(a.textContent)) a.textContent = 'Beyond Radix Physical Therapy';
    });
    var made = document.createElement('small');
    made.className = 'copyright__content br-foot-made';
    made.innerHTML = '<i aria-hidden="true"></i>Designed by a physical therapist in New Jersey';
    c.appendChild(made);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Sections ease in as they scroll into view (skipped on product pages and for reduced motion) */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  function run() {
    if (root.classList.contains('br-combo')) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('main > .shopify-section'));
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top < vh * 0.9) return;
      s.classList.add('br-rv'); io.observe(s);
    });
    root.classList.add('br-motion');
    window.addEventListener('beforeprint', function () { secs.forEach(function (s) { s.classList.add('is-in'); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Footer "Contact Us" column: number becomes tap-to-call, address and a map sit underneath.
   Edit the number or address in the footer block (Theme editor) and this picks it up. */
(function () {
  var DEF_ADDRESS = '209 Pierson Ave, Edison, NJ 08837';
  var DEF_PHONE = '(201) 210-2315';
  function ic(d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function run() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('footer.footer .footer-block'));
    var col = null;
    blocks.forEach(function (b) { var h = b.querySelector('.footer-block__heading'); if (h && /contact/i.test(h.textContent)) col = b; });
    var host = col ? col.querySelector('.footer-block__details-content > div') || col.querySelector('.footer-block__details-content') : document.querySelector('footer.footer .footer-block__brand-info');
    if (!host || host.querySelector('.br-foot-contact')) return;
    var phone = DEF_PHONE, address = DEF_ADDRESS, email = '';
    if (col) {
      Array.prototype.forEach.call(host.querySelectorAll('li, p'), function (li) {
        var t = li.textContent.replace(/\s+/g, ' ').trim();
        if (/^address\s*:?/i.test(t)) { var a = t.replace(/^address\s*:?\s*/i, ''); if (a.length > 6) address = a; }
        else if (/@/.test(t)) email = t.replace(/^e-?mail\s*:?\s*/i, '');
        else if ((t.match(/\d/g) || []).length >= 7 && !/map/i.test(t)) phone = t.replace(/^(phone|call|tel)\s*:?\s*/i, '');
      });
      Array.prototype.forEach.call(host.querySelectorAll('ul, p'), function (n) { n.remove(); });
    }
    var tel = phone.replace(/[^\d+]/g, '');
    var q = encodeURIComponent('Beyond Radix Physical Therapy, ' + address);
    var box = document.createElement('div');
    box.className = 'br-foot-contact';
    box.innerHTML =
      '<a href="tel:' + tel + '">' + ic('<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/>') + '<span>' + esc(phone) + '</span></a>' +
      (email ? '<a href="mailto:' + esc(email) + '">' + ic('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>') + '<span>' + esc(email) + '</span></a>' : '') +
      '<address><a href="https://www.google.com/maps/search/?api=1&query=' + q + '" target="_blank" rel="noopener">' + ic('<path d="M12 22s7-6.1 7-12a7 7 0 0 0-14 0c0 5.9 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/>') + '<span>' + esc(address) + '</span></a></address>' +
      '<div class="br-foot-map"><iframe title="Beyond Radix on Google Maps" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps?q=' + q + '&output=embed"></iframe><a class="br-foot-map__go" href="https://www.google.com/maps/dir/?api=1&destination=' + q + '" target="_blank" rel="noopener">Directions</a></div>';
    host.appendChild(box);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Warranty page: the same page banner as the other inner pages */
(function () {
  function run() {
    var main = document.querySelector('main'); if (!main || main.querySelector('.br-ph') || !main.querySelector('#warranty')) return;
    var s = document.createElement('section'); s.className = 'br-ph';
    s.innerHTML = '<div class="page-width br-ph__in"><nav class="br-ph__crumbs" aria-label="Breadcrumb"><a href="/">Home</a><span aria-hidden="true">/</span><span>Warranty</span></nav><p class="br-ph__eyebrow"><i aria-hidden="true"></i>Beyond Radix care</p><h1 class="br-ph__title">Warranty <em>&amp; claims</em></h1><p class="br-ph__lead">Every kit is covered for a full year. Register yours in two minutes, or tell us what went wrong and we will make it right.</p></div><div class="br-ph__art" aria-hidden="true"><span></span><span></span><span></span></div>';
    main.insertBefore(s, main.firstElementChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Home: "Everything you need" shows the four kit boxes; newsletter shows the pre-order offer */
(function () {
  function run() {
    var copy = document.querySelector('.nws__copy');
    if (copy && !copy.querySelector('.nws__offer')) {
      var b = document.createElement('p'); b.className = 'nws__offer';
      b.innerHTML = '<b>20% off</b> Pre-orders for subscribers';
      copy.insertBefore(b, copy.firstChild);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
